import { render, staticRenderFns } from "./BasicAlert.vue?vue&type=template&id=ef078e9e&scoped=true&"
import script from "./BasicAlert.vue?vue&type=script&lang=js&"
export * from "./BasicAlert.vue?vue&type=script&lang=js&"
import style0 from "./BasicAlert.vue?vue&type=style&index=0&id=ef078e9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef078e9e",
  null
  
)

export default component.exports